export const enum DetailedPatientMutationNames {
  updatePatients = 'DETAILED_PATIENT_UPDATE_PATIENTS',
}

export const enum DetailedPatientActionNames {
  getDetailedPatientById = 'DETAILED_PATIENT_GET_DETAILED_PATIENT_BY_ID',
}

export const enum DetailedPatientGetterNames {
  patients = 'DETAILED_PATIENT_PATIENTS',
}
